<template>
  <tr>
    <td>
      <div class="info">
        <a :href="productLink">
          <NewImage class="mr-2" :url="productImg" :size="'_w120_h150'" :name="productName" />
        </a>
        <p>
          <a :href="productLink">{{ productName }}</a>
        </p>
        <p class="item-order">
          <span class="mr-2">{{ item.NineDigitsBarcode }}</span>
        </p>
        <p>
          顏色：<span class="item-color mr-2">{{ item.Colors[0].ColorName }}</span>
        </p>
        <p v-if="item.EventName !== null" class="h6 text-secondary">
          <span class="free-label lh-1">（活動）</span>
          <span class="h6 event-name">{{ item.EventName }}</span>
        </p>
        <div class="clearfix" />
      </div>
    </td>
    <td>
      <span>價錢</span>
      <div>
        <span class="origin-price d-inline-block mx-1">NT.{{ originPrice }}</span>
      </div>
    </td>
    <td>
      <span>特價</span>
      <div class="sell-price d-inline-block mx-1">
        NT.{{ eventPrice > 0 && eventPrice < sellPrice ? eventPrice : sellPrice }}
      </div>
    </td>
    <td>
      <span>加入購物車</span>
      <div>
        <a
          style="cursor: pointer"
          class="open-dialog"
          @click="showCartDialog(item.Colors[0].CustomMarketID)"
        >
          <i class="icon icon__cart_addtobag">ADD TO BAG</i>
        </a>
      </div>
    </td>
    <td>
      <span>刪除</span>
      <div>
        <a
          style="cursor: pointer"
          class="btn-delete"
          @click.prevent="cancelFavorite(item.Colors[0].CustomMarketID, idx)"
        >
          <i class="icon icon__cart_remove">刪除</i>
        </a>
      </div>
    </td>
  </tr>
</template>

<script setup>
import { ref } from 'vue';

import NewImage from '@global/components/common/Image/NewImage.vue';

import useFavorite from '@global/composable/member/useFavorite';

const { cancelFavorite, showCartDialog } = useFavorite();

const props = defineProps({
  item: {
    type: Object,
    required: true,
  },
  idx: {
    type: Number,
    required: true,
  },
});

const productName = ref(props.item.Name);
const productImg = ref(props.item.Colors[0].Covers[0]);
const productLink = ref(props.item.Colors[0].MarketUrl);
const originPrice = ref(props.item.OriginPrice);
const sellPrice = ref(props.item.SellPrice);
const eventPrice = ref(props.item.EventPrice);
</script>
